/* eslint prefer-destructuring: 0 */
/* eslint no-lonely-if: 0 */

import { throttleDomAfterAsync } from '../helpers/throttle';
import FocusTrapper from './class-focus-trapper';

const body = document.body;
const search = document.querySelector('.site-search--js');
const searchType = body.classList.contains('has-overlay-search')
  ? 'overlay'
  : 'top';
const searchInput = search ? search.querySelector('.search__input') : null;
const searchToggles = document.querySelectorAll('.js-toggle-site-search');

let triggerElement = null;

/**
 * Set up focus trap for Overlay search.
 */
let focusTrapper = null;
let overlayModal = null;
if (searchType === 'overlay') {
  overlayModal = document.querySelector('.site-search--overlay');
  focusTrapper = new FocusTrapper(overlayModal);
}

/**
 * Open search.
 */
function openSearch() {
  // The element that toggled the search.
  triggerElement = document.activeElement || document.body;

  // Set classes / attrs.
  body.classList.add('search-open');
  search.setAttribute('aria-hidden', false);
  search.removeAttribute('hidden');

  // Trap focus.
  if (focusTrapper) {
    focusTrapper.bind();
  }

  // Set focus.
  searchInput.focus();
}

/**
 * Close search.
 */
function closeSearch() {
  // Set classes / attrs.
  body.classList.remove('search-open', 'temp-high-z');
  search.setAttribute('aria-hidden', true);
  search.setAttribute('hidden', '');

  // Untrap focus.
  if (focusTrapper) {
    focusTrapper.unbind();
  }

  // Remove focus.
  searchInput.blur();

  // Return focus to element that toggled search.
  if (triggerElement) {
    triggerElement.focus();
    triggerElement = null;
  }
}

/**
 * Close search w/ keyboard.
 */
function closeSearchOnEscape(e) {
  if (body.classList.contains('search-open') && e.code === 'Escape') {
    closeSearch();
  }
}

/**
 * Close search w/ click outside search box.
 */
function closeSearchOnOuterClick(e) {
  if (body.classList.contains('search-open') && !search.contains(e.target)) {
    closeSearch();
  }
}

/**
 * Toggle search open/closed.
 */
function toggleSearch(e) {
  e.preventDefault();
  e.stopPropagation();

  if (body.classList.contains('search-open')) {
    closeSearch();
  } else {
    openSearch();
  }
}

/**
 * Handle focus for Top search.
 *
 * @description Closes Top search and returns focus back to trigger button when tabbing beyond search.
 */
function topSearchFocus(e) {
  const focusableElements = 'button, [href], input';
  const firstFocusableElement = search
    ? search.querySelectorAll(focusableElements)[0]
    : '';
  const focusableContent = search
    ? search.querySelectorAll(focusableElements)
    : '';
  const lastFocusableElement = focusableContent
    ? focusableContent[focusableContent.length - 1]
    : '';

  const isTabPressed = e.key === 'Tab';

  if (!isTabPressed || searchType === 'overlay') {
    return;
  }

  if (e.shiftKey) {
    if (document.activeElement === firstFocusableElement) {
      triggerElement.focus();
      triggerElement = null;
      closeSearch();
      e.preventDefault();
    }
  } else {
    if (document.activeElement === lastFocusableElement) {
      triggerElement.focus();
      triggerElement = null;
      closeSearch();
      e.preventDefault();
    }
  }
}

/**
 * Watch for input change.
 */
const throttledInputChange = throttleDomAfterAsync((e) => {
  const l = String(e.target.value).length;
  const parent = e.target.closest('form');

  if (!parent) {
    return;
  }

  if (l) {
    parent.classList.add('has-value');
  } else {
    parent.classList.remove('has-value');
  }
}, 200);

/**
 * Run site search.
 */
function siteSearch() {
  // Exit if no site search.
  if (!search) {
    return;
  }

  // Toggle search.
  searchToggles.forEach((toggle) => {
    toggle.addEventListener('click', toggleSearch);
  });

  // Close search with ESC key.
  document.addEventListener('keyup', closeSearchOnEscape);

  // Close search with outside click.
  document.addEventListener('click', closeSearchOnOuterClick);

  // Add 'has-value' class to input if value is present.
  searchInput.addEventListener('input', throttledInputChange);

  // Handle top search focus.
  document.addEventListener('keydown', topSearchFocus);
}
siteSearch();

// Prevent empty searches on older browsers.
document.querySelectorAll('[data-searchform]').forEach((form) => {
  form.addEventListener('submit', (e) => {
    const searchInputValue = form.querySelector('input').value;
    if (searchInputValue === '') {
      e.preventDefault();
    }
  });
});
